import styled, { css } from 'styled-components';

import {
  colors,
  layers,
  typography,
} from '../../theme';

import {
  TagBox,
} from '../../elements';

export const Wrapper = styled.nav`
  ${typography.BODY__SMALL}
  left: 0;
  opacity: 0;
  padding: ${10 / typography.BASE_FONT_SIZE}rem;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity .2s ease-in-out,
              visibility .2s ease-in-out;
  visibility: hidden;
  z-index: ${layers.INTRO__FILTERS};

  ${(props) => props.active && css`
    opacity: 1;
    transition: opacity .2s ease-in-out .5s,
                visibility .2s ease-in-out .5s;
    visibility: visible;
  `}
`;

export const Row = styled.div`
  /* display: flex; */
  padding-left: ${10/typography.BASE_FONT_SIZE}rem;
  /* flex-wrap: wrap; */
  text-indent: -${10/typography.BASE_FONT_SIZE}rem;
`;

export const Box = TagBox.extend`
  background: ${colors.GREY__WHITE};
  cursor: pointer;
  display: inline-block;
  margin-bottom: -1px;
  margin-right: -1px;
  text-indent: 0;
  white-space: nowrap;

  &:hover,
  &.active {
    background: ${colors.WHITE};
  }
`;

export const ButtonAlt = Box.withComponent('a').extend`
  margin-top: 20px;
`;
export const Button = Box.withComponent('a');



// WEBPACK FOOTER //
// ./src/components/IntroCloudFilter/style.js